export const removeSpecialChar = (value: string) => {
  return value.replace(/[^a-zA-Z0-9]/g, '')
}

export const removeSpaceAndSpecialChar = (value: string) => {
  return value.replace(/[^a-zA-Z0-9\s]/g, '')
}
